var _defs, _rect, _rect2, _rect3, _line, _text, _text2, _text3, _text4, _text5, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModernMinimalist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 520",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "noise"
  }, /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: 0.85,
    numOctaves: 2,
    stitchTiles: "stitch"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.04 0"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 520,
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 399,
    height: 519,
    fill: "none",
    stroke: "#e3ddd2",
    strokeWidth: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 520,
    filter: "url(#noise)",
    opacity: 0.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 40,
    x2: 200,
    y2: 100,
    stroke: "#b08a4c",
    strokeWidth: 1.4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 180,
    textAnchor: "middle",
    fontFamily: "Marcellus, serif",
    fontSize: 22,
    letterSpacing: 6,
    fill: "#2a2421"
  }, "JULIET")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 240,
    textAnchor: "middle",
    fontFamily: "Italianno, cursive",
    fontSize: 44,
    fill: "#b08a4c"
  }, "&amp;")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 300,
    textAnchor: "middle",
    fontFamily: "Marcellus, serif",
    fontSize: 22,
    letterSpacing: 6,
    fill: "#2a2421"
  }, "ROMEO")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 360,
    textAnchor: "middle",
    fontFamily: "Cormorant SC, serif",
    fontSize: 11,
    letterSpacing: 3,
    fill: "#2a2421"
  }, "SATURDAY \xB7 SEPTEMBER TWELFTH")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 380,
    textAnchor: "middle",
    fontFamily: "Cormorant SC, serif",
    fontSize: 10,
    letterSpacing: 3,
    fill: "#6b5d57"
  }, "TWO THOUSAND TWENTY SIX")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 420,
    x2: 200,
    y2: 480,
    stroke: "#b08a4c",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModernMinimalist);
export default __webpack_public_path__ + "static/media/modernMinimalist.882dbde91e0961c47b08c63d36e89654.svg";
export { ForwardRef as ReactComponent };